import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'
import { QuestionIcon } from '../../Assets/AllSvg'

const CopydataModal = ({ copyData, setCopyData, cancelRequest, setCancelRequest, }) => {
    return (
        <>
            <div>
                <Transition.Root show={copyData} as={Fragment}>
                    <Dialog as="div" className="relative z-10" onClose={setCopyData}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </Transition.Child>

                        <div className="fixed inset-0 z-10 overflow-y-auto">
                            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                >
                                    <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[448px] text-[#414552]">
                                        <div>
                                            <div className="font-semibold p-[16px_20px] border-b-[1px] border-[#ebeef1] text-base text-gray-900">Enter recipient&apos;s account ID</div>
                                        </div>
                                        <div className='p-[16px_20px] border-b-[1px] border-[#ebeef1] text-sm text-gray-900'>
                                            <p>To send a copy of your customer data, enter the account ID of the intended recipient. The recipient will be notified of the copy request.</p>
                                            <p className='mt-2'>When the recipient accepts the copy request, your <span className='font-semibold cursor-pointer text-[#625afa]'>customer objects</span> and their associated payment information will be copied to the recipient's account.<span className='text-[#625afa] cursor-pointer font-semibold'> Learn more</span>
                                            </p>
                                            <div className='mt-3'>
                                                <div className='flex font-semibold gap-3 items-center'>Account ID <QuestionIcon /></div>
                                                <input placeholder='acct_0000000000' type="text" className="input_focus_shadow mt-2 max-w-[240px] font-normal px-2 w-full bg-white rounded-[6px] focus:outline-none h-[24px] text-[13px]" />
                                            </div>
                                        </div>
                                        <div className="font-semibold p-[16px_20px] flex justify-end text-base text-gray-900 gap-2">
                                            <button className="border-[2px] h-[30px] rounded-[6px] border-[#ebeef1] text-[14px] font-semibold p-[0_8px] " onClick={() => { setCancelRequest(true); setCopyData(false) }}>Cancel</button>
                                            <button className="border-[2px] h-[30px] rounded-[6px] border-[#625afa] text-white bg-[#625afa] text-[14px] font-semibold p-[0_8px]" onClick={() => setCopyData(false)}>Continue</button>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </Dialog>
                </Transition.Root>
            </div>
            <div>
                <Transition.Root show={cancelRequest} as={Fragment}>
                    <Dialog as="div" className="relative z-10" onClose={setCancelRequest}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </Transition.Child>

                        <div className="fixed inset-0 z-10 overflow-y-auto">
                            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                >
                                    <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[448px] text-[#414552]">
                                        <div>
                                            <div className="font-semibold p-[16px_20px] border-b-[1px] border-[#ebeef1] text-base text-gray-900">
                                                <span>Cancel copy request?</span>
                                            </div>
                                        </div>
                                        <div className='p-[16px_20px] border-b-[1px] border-[#ebeef1] text-sm text-gray-900'>
                                            <p>Are you sure you want to exit the customer sharing process?</p>
                                        </div>
                                        <div className="font-semibold p-[16px_20px] flex justify-end text-base text-gray-900 gap-2">
                                            <button className="border-[2px] h-[30px] rounded-[6px] border-[#ebeef1] text-[14px] font-semibold p-[0_8px] " onClick={() => { setCopyData(true); setCancelRequest(false) }}>Cancel</button>
                                            <button className="border-[2px] h-[30px] rounded-[6px] border-[#625afa] text-white bg-[#d81b4a] text-[14px] font-semibold p-[0_8px]" onClick={() => { setCopyData(false); setCancelRequest(false) }}>Cancel request</button>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </Dialog>
                </Transition.Root>
            </div>
        </>
    )
}

export default CopydataModal